import { PureFunctional, React } from '../../react';
import Panel, { ITabProps } from './tab';

export interface ITabSwitchProps {
    activeIndex: number;
    children?: Array<React.ReactElement<ITabProps>> ;
  }
export default PureFunctional<any|ITabSwitchProps>(`TabsSwitch`)(
    ({ activeIndex, children }) => (
        
        <div className={'switch'}>
            {children.qSelect((tab: any, idx: any) => {
                return idx !== activeIndex
                    ? null
                    : (
                        <Panel key={idx} id={'panel-' + idx.toString()} active={idx === activeIndex}>
                        {(tab.props as React.Props<any>).children}
                        </Panel>
                      );
            })}
        </div>
    ));



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/tabs/switch.tsx